import { createFileRoute } from '@tanstack/react-router'

import { MyQaRuns } from '@/components/qa/my-qa-runs'

export const Route = createFileRoute('/_app/ma-recette')({
  component: MyQaRuns,
})
